import { Navigate } from 'react-router-dom';
import type { FC } from 'react';

export const AnchorRedirect: FC<{ hash: string }> = ({ hash }) => {
    const to = `/${hash.startsWith('#') ? hash : `#${hash}`}`;
    return <Navigate to={to} replace />;
};